<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Finance Reports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {PageHeader, Layout},
name: "default",
  data() {
    return {
      title: "Finance Reports",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Finance Reports",
          active: true
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>
